<template>
    <textarea :value="value" @input="onInput"></textarea>
</template>

<script type="text/babel">
import autosize from 'autosize'

export default {
    props: ['value'],

    data() {
        return {
            changeOriginatedFromInput: false,
        }
    },

    watch: {
        value() {
            if (this.$el && !this.changeOriginatedFromInput) {
                this.$nextTick(() => this.$el.dispatchEvent(this.createEvent('autosize:update')))
            }
            this.changeOriginatedFromInput = false
        },
    },

    mounted() {
        autosize(this.$el)
    },

    methods: {
        createEvent(name) {
            try {
                return new Event(name, { bubbles: true })
            } catch (e) {
                // IE does not support `new Event()`
                const event = document.createEvent('Event')
                event.initEvent(name, true, false)
                return event
            }
        },

        onInput(event) {
            this.changeOriginatedFromInput = true
            this.$emit('input', event.target.value)
        },
    },
}
</script>
